import { Modal, Button, ModalBody, ModalFooter } from "react-bootstrap";

const DisclaimerModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>
          Spectra Plasmonics Web Application Disclaimer{" "}
        </Modal.Title>
      </Modal.Header>
      <ModalBody>
        <h5> 1. Content</h5>
        <p>
          The contents of this Spectra Plasmonics (“<b>Spectra</b>”) web
          application (app.spectraplasmonics.com, “<b>Web App</b>”), such as
          text, graphics, Raman spectra, and other materials contained on the
          Web App (“<b>Content</b>”), are for informational purposes only. The
          Content is not intended to be a substitute for professional medical
          advice, diagnosis, or treatment, and the Content is not intended to
          provide legal or regulatory advice.
        </p>
        <h5> 2. Use of Product for Drug Analysis</h5>
        <p>
          The Amplifi ID Raman Spectrometer, Web App, and associated attachments
          and accessories (the “<b>Product</b>”) is provided to assist in the
          analysis of the components of suspected illicit drugs in facilities
          such as supervised injection sites, public health sites, or similar,
          and by law enforcement personnel. Spectra does not supply or otherwise
          make available any illegal or prohibited substances. The Product is
          provided to assist suitably qualified and experienced staff to detect
          dangerous components, compounds or materials within suspected illicit
          drugs, but no representation or warranty is made that all or any such
          dangerous components, compounds or materials will be detected.
          Further, it is the nature of illicit and illegal substances that they
          pose a threat to the health and wellbeing of any individual who takes
          such substances. Spectra in no way guarantees that any substance is
          safe to use. No representation or warranty is given that any person
          who takes a substance that was screened using the Product will not
          suffer an adverse consequence notwithstanding any result or lack of
          results produced by the Product, including without limitation the lack
          of any warning or warning indicator. Any person taking, injecting or
          otherwise using any illicit or illegal substance does so entirely at
          their own risk.
        </p>

        <p>
          Additionally, Spectra makes no representations and provides no
          warranties or conditions of any kind, whether express, implied,
          statutory or otherwise, and specifically disclaims all implied
          representations, warranties and/or conditions, including any
          representations, warranties and/or conditions of merchantability,
          merchantable quality, durability, title, non-infringement,
          satisfactory quality or fitness for a particular purpose, to the
          maximum extent permitted by applicable law. Without limiting the
          above, Spectra does not make any representation or warranty in respect
          of any result, analyses or output generated by the Product, including
          in particular but without limitation that all or any dangerous
          components, compounds or materials will be detected. Further, it is
          the nature of illicit and illegal substances that they pose a threat
          to the health and wellbeing of any individual who takes such
          substances. No representation or warranty is given that any person who
          takes a substance that was screened using the Product will not suffer
          an adverse consequence notwithstanding any result or lack of results
          produced by the Product, including without limitation the lack of any
          warning or warning indicator. Any person taking, injecting or
          otherwise using any illicit or illegal substance does so entirely at
          their own risk the disclaimer set out above.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button variant='secondary' onClick={handleClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DisclaimerModal;
